import { Coordinates } from "../../Util/Math/Coordinates"
import { useCtrlKey, useKeyCtrlMenuCoordinates, useKeyCtrlMenuIsOpen, useKeyCtrlMenuSetMap, useKeyCtrlMenuStore } from "./KeyCtrlMenuStore"
import { ControlledMenu, MenuItem, MenuRadioGroup, SubMenu } from "@szhsin/react-menu"
import { Key } from "../../Data/HexMap/Key"
import { produce } from "immer"
import { HexMap } from "../../Data/HexMap/HexMap"
import { HexMapModifier } from "../../Data/HexMap/HexMapModifier"
import { KeyCtrlMenuState } from "./KeyCtrlMenuState"
import { Note } from "../../Data/HexMap/Note"

export function KeyCtrlMenu(){
    const coords:Coordinates = useKeyCtrlMenuCoordinates()
    const setIsOpen:Function = useKeyCtrlMenuStore((state:KeyCtrlMenuState)=>state.setIsOpen)
    let key:Key|null = useCtrlKey()
    const setMap:Function = useKeyCtrlMenuSetMap()
    const hideKey = () => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(key !== null){
              mod.keys_setVisible([key.params.keyIndex], false)
            }
        })) 
        setIsOpen(false)
    }
    const toggleDefined = () => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(key !== null){
              mod.keys_setDefined([key.params.keyIndex], !key.defined)
            }
        })) 
        setIsOpen(false)
    }
    const setSelectedState = (state:number) => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(key !== null){
              mod.keys_setSelectedState([key.params.keyIndex], state)
            }
        })) 
        setIsOpen(false)
    }
    const ghost = () => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(key !== null){
              mod.keys_toggleClasses([key.params.keyIndex], ['ghosted'])
            }
        })) 
        setIsOpen(false)
    }    
    const open = () => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(key !== null){
              mod.keys_setOpen([key.params.keyIndex], !key.open)
            }
        })) 
        setIsOpen(false)
    }
    return <div className={'key-ctrl-menu'}>
    <ControlledMenu
        anchorPoint={{x:coords.x,y:coords.y}}
        state={useKeyCtrlMenuIsOpen() ? 'open' : 'closed'}
        direction="right"
        onClose={() => {setIsOpen(false)}}
      >
        <MenuItem onClick={open}>Open/Close</MenuItem>
        <MenuItem onClick={toggleDefined}>Toggle Defined</MenuItem>
        <SubMenu label={'Selected State'}>
          <MenuItem onClick={()=>{setSelectedState(Note.SelectedState_Default)}}>Default</MenuItem>
          <MenuItem onClick={()=>{setSelectedState(Note.SelectedState_Selected)}}>Selected</MenuItem>
          <MenuItem onClick={()=>{setSelectedState(Note.SelectedState_Hilited)}}>Highlighted</MenuItem>
        </SubMenu>
        <MenuItem onClick={ghost}>Ghost/UnGhost</MenuItem>
        <MenuItem onClick={hideKey}>Hide</MenuItem>
      </ControlledMenu>
    </div>
}